/** Landing page → "Try a demo": one click signs a visitor in to a demo institution as admin, teacher or student. */
import React from 'react';
import { DEMO_INSTITUTIONS, DEMO_PASSWORD } from '../../data/demoLogins';

const TryDemo: React.FC<{ onLogin: (email: string, password: string) => void }> = ({ onLogin }) => (
    <section id="demo" className="relative overflow-hidden py-20" style={{ background: 'linear-gradient(135deg,#04121f,#0b1a33,#04121f)' }}>
        <div className="mx-auto max-w-6xl px-4">
            <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-sky-300">Try it yourself</p>
            <h2 className="mt-2 text-center text-3xl font-black text-white md:text-4xl">Open a live demo</h2>
            <p className="mx-auto mt-3 max-w-2xl text-center text-slate-300">
                Sign in to a real demo institution as the admin, a teacher or a student. Each demo includes up to 3 MEF-AID generations per feature, and everything resets every night.
            </p>
            {(['Saudi Arabia', 'Nigeria'] as const).map(region => (
            <div key={region} className="mt-10">
            <h3 className="mb-4 text-lg font-bold text-sky-200">{region === 'Saudi Arabia' ? 'Saudi Arabia · المملكة العربية السعودية' : 'Nigeria'}</h3>
            <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
                {DEMO_INSTITUTIONS.filter(d => d.region === region).map(d => (
                    <div key={d.id} className="flex flex-col rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur">
                        <span className="w-fit rounded-full px-3 py-1 text-xs font-bold text-white" style={{ background: d.accent }}>{d.kind}</span>
                        <h3 className="mt-3 text-xl font-black text-white">{d.name}</h3>
                        {d.nameAr && <p dir="rtl" lang="ar" className="mt-1 text-base font-semibold text-slate-300">{d.nameAr}</p>}
                        <p className="mt-2 flex-1 text-sm text-slate-300">{d.blurb}</p>
                        <div className="mt-5 space-y-2">
                            {d.logins.map(l => (
                                <button key={l.role} onClick={() => onLogin(l.email, DEMO_PASSWORD)}
                                    className="flex w-full items-center justify-between rounded-xl bg-white px-4 py-2.5 text-left text-sm font-bold text-slate-900 transition hover:scale-[1.02]">
                                    <span>Enter as {l.role}</span><span className="text-xs font-semibold text-slate-500">{l.who}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            </div>
            ))}
            <p className="mt-6 text-center text-xs text-slate-400">Demo password for every login: <span className="font-mono text-slate-200">{DEMO_PASSWORD}</span></p>
        </div>
    </section>
);

export default TryDemo;
